module.exports = __webpack_public_path__ + "img/queue.3539777b.png";